











import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import TableCell from './TableCell.vue'

@Component({
  components: { TableCell },
})
export default class TableRow extends Vue {
  @Prop({ default: 'div' })
  tag: string

  @Prop({ default: 'div' })
  child: string
}
